import { render, staticRenderFns } from "./AttendancesStats.vue?vue&type=template&id=5c20a92e&"
import script from "./AttendancesStats.vue?vue&type=script&lang=js&"
export * from "./AttendancesStats.vue?vue&type=script&lang=js&"
import style0 from "./AttendancesStats.vue?vue&type=style&index=0&id=5c20a92e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports